import { z } from 'zod';
import { ElementSchema } from './enums.js';
// --- elements.json (§7.7, §10.4) ---
// 5x5 matchup matrix with 0.75 / 1.0 / 1.25 multipliers
const MultiplierSchema = z.union([
    z.literal(0.75),
    z.literal(1.0),
    z.literal(1.25),
]);
const MatchupRowSchema = z.object({
    wood: MultiplierSchema,
    fire: MultiplierSchema,
    earth: MultiplierSchema,
    wind: MultiplierSchema,
    water: MultiplierSchema,
});
export const ElementsConfigSchema = z.object({
    elements: z.array(ElementSchema).length(5),
    matchup_matrix: z.object({
        wood: MatchupRowSchema,
        fire: MatchupRowSchema,
        earth: MatchupRowSchema,
        wind: MatchupRowSchema,
        water: MatchupRowSchema,
    }),
});
// --- synergies.json (§8) ---
// Synergies are keyed by axis (animal | element) and value (specific animal/element).
// Each has thresholds with a stat-bonus + optional triggered-effect description.
export const SynergyTierSchema = z.object({
    threshold: z.union([z.literal(2), z.literal(3), z.literal(5)]),
    stat_bonus: z
        .object({
        hp: z.number().int().optional(),
        atk: z.number().int().optional(),
    })
        .optional(),
    effect_description: z.string().optional(), // human-readable; logic lives in code
    // Snappy ~40-char version for the shop synergy sidebar (where the full
    // sentence wraps to 3+ lines and crowds the panel). The codex / hover
    // tooltip continue to use the full `effect_description`. Optional;
    // falls back to `effect_description` when absent.
    effect_description_short: z.string().optional(),
    effect_id: z.string().optional(), // simulator switch key, e.g. "bird_3_threshold_strike_on_crumple"
});
export const SynergyDefSchema = z.object({
    axis: z.enum(['animal', 'element']),
    key: z.string(), // matches AnimalSchema or ElementSchema value
    display_name: z.string(),
    tiers: z.array(SynergyTierSchema).min(1),
});
export const SynergiesConfigSchema = z.object({
    synergies: z.array(SynergyDefSchema),
});
// --- shop_distribution.json (§5) ---
// Per shop level (1-5), probability weights for each tier appearing in a slot.
export const ShopLevelWeightsSchema = z.object({
    level: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]),
    weights: z.object({
        '1': z.number().nonnegative(),
        '2': z.number().nonnegative(),
        '3': z.number().nonnegative(),
        '4': z.number().nonnegative(),
        '5': z.number().nonnegative(),
    }),
});
export const ShopDistributionConfigSchema = z.object({
    by_level: z.array(ShopLevelWeightsSchema).length(5),
});
// --- paper_textures.json (§14) ---
export const PaperTextureSchema = z.object({
    id: z.string(),
    display_name: z.string(),
    // Either an inline SVG filter ref or a tileable asset path.
    svg_filter_id: z.string().optional(),
    asset_path: z.string().optional(),
});
export const PaperTexturesConfigSchema = z.object({
    textures: z.array(PaperTextureSchema).min(1),
});
//# sourceMappingURL=system-data.js.map